import { render, staticRenderFns } from "./MergeInvestigation.vue?vue&type=template&id=2b5705bf&scoped=true&"
import script from "./MergeInvestigation.vue?vue&type=script&lang=js&"
export * from "./MergeInvestigation.vue?vue&type=script&lang=js&"
import style0 from "./MergeInvestigation.vue?vue&type=style&index=0&id=2b5705bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5705bf",
  null
  
)

export default component.exports